import React from "react";

const Filter = ({name, onChange, checked, label, type = "checkbox", value}) => {

  return (
     <div id={name} className="ft_dealer-locator__checkbox">
        <label>
          <input type={type} value={value} name={name} onChange={onChange} checked={checked}/>
          <span className="ft_dealer-locator__label caption checkmark"></span>
          <span className="caption whitespace-nowrap">{label}</span>
        </label>
      </div>
  );

}

export default Filter;
